// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202603301019/js/" + chunkId + "." + {"44":"c792ab07","225":"b346ef34","481":"f0c391a3","486":"11b2871e","770":"9320667f"}[chunkId] + ".0.9047755627634269.chunk.js";
};